import React, { useState, useRef, useEffect } from "react";
import { DiYii } from "react-icons/di";

function TemplateNames({
  template,
  setTemplate,
  selectedCategory,
  selectedSubCat,
}) {
  const nameRef = useRef(null);
  const [isOverflow, setIsOverflow] = useState(false);

  const handlename = (val) => {
    const formatted = val
      .toLowerCase()
      .replace(/ /g, "_")
      .replace(/[^a-z0-9_]/g, "")
      // .replace(/_+/g, "_"); // collapse multiple underscores

    setTemplate((prev) => ({
      ...prev,
      name: formatted,
    }));
  };

  const handlelanguage = (val) => {
    setTemplate((prev) => ({
      ...prev,
      language: val,
    }));
  };

  useEffect(() => {
    if (nameRef.current) {
      setIsOverflow(nameRef.current.scrollWidth > nameRef.current.clientWidth);
    }
  }, [template.name]);

  return (
    <div>
      {/* DISPLAY HEADER */}
      <div
        ref={nameRef}
        className="mb-2 bg-white p-6 rounded-lg border
             max-w-full overflow-x-auto scrollbar-thin 
             scrollbar-thumb-gray-300 scrollbar-track-gray-100 
             scrollbar-thumb-rounded-full scrollbar-track-rounded-ful pb-1"
      >
        <h2 className="text-xl font-semibold flex items-start gap-3">
          {/* KEEP ICON as-is but prevent it from shrinking */}
          <DiYii
            size={35}
            className="bg-green-600 p-1 rounded-lg text-white flex-shrink-0"
          />

          {/* text wrapper — preserve your category div (not a span) */}
          <div className="min-w-0">
            <div className="whitespace-nowrap">
              <span>
                {template.name || "your_template_name"}
                {!isOverflow && ` • ${template.language || "English"}`}
              </span>
            </div>

            {isOverflow && (
              <div className="mt-1 text-gray-700">
                {template.language || "English"}
              </div>
            )}

            <div className="text-sm text-gray-500">
              {selectedCategory || "Marketing"} · {selectedSubCat || "Default"}
            </div>
          </div>
        </h2>
      </div>

      {/* iNPUTS */}
      <div className="mb-2 bg-white p-6 rounded-lg border">
        <h2 className="text-lg font-extrabold mb-4">
          Template Name and Language
        </h2>

        <div className="flex items-start gap-6">
          <div className="flex-1">
            <label className="block mb-2 font-semibold text-gray-700">
              Template Name
            </label>
            <div className="relative">
              <input
                type="text"
                value={template.name}
                onChange={(e) => handlename(e.target.value)}
                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none 
  focus:ring-2 focus:ring-blue-300 focus:border-blue-300 overflow-x-auto whitespace-nowrap"
                placeholder="Enter template name"
                maxLength={512}
              />
              <div className="absolute right-3 top-1/2 transform -translate-y-1/2 text-sm text-gray-500 bg-white px-1 pointer-events-none z-10">
                {template?.name ? template?.name.length : 0} /512
              </div>
            </div>
          </div>

          <div className="w-48">
            <label className="block mb-2 font-semibold text-gray-700">
              Choose Language:
            </label>
            <select
              value={template.language}
              onChange={(e) => handlelanguage(e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
            >
              <option value="en_US">English</option>
              <option value="ur">Urdu</option>
              <option value="fr">French</option>
            </select>
          </div>
        </div>

        <div className="mt-4 text-lg font-semibold"></div>
      </div>
    </div>
  );
}

export default TemplateNames;

